import type { StudioJob } from '@/features/ai/studioTypes'

/**
 * Четвёртая ветка цепочки §7.4: перевод прошёл, а картинки второго языка не
 * поставлены. Признак — событие `stage: "images"` при отсутствии
 * `next_job_id`.
 *
 * Причин у контракта ТРИ — «не хватило кредитов», «картиночный воркфлоу не
 * разбудили» и «автор снял тумблер дорисовки», — но различаются они ТОЛЬКО
 * словами внутри сообщения, отдельного кода нет. Разбирать русскую фразу
 * подстрокой запрещено (CLAUDE.md: не восстанавливать данные из отображаемой
 * строки), поэтому мы отдаём текст сервера ДОСЛОВНО и предлагаем ОДНО действие
 * — ручной старт отрисовки. Если причина всё-таки в деньгах, автор упрётся в
 * `400 not_enough_ai_credits` на старте и получит кнопку пополнения от общего
 * баннера отказов (под-проект G).
 *
 * Своей подсказки «нарисовать можно на экране картинок» рядом не пишем: её уже
 * несёт серверный текст отказавшегося, и второй голос об одном и том же
 * разошёлся бы с первым при первой же правке формулировки на бэке.
 *
 * Тем же уведомлением закрывается событие «мест под картинки больше, чем
 * помещается в один прогон: N осталось на потом» — оно приходит той же стадией.
 */
export const translationImagesNotice = (job: StudioJob): string | null => {
  if (job.type !== 'course_translation' || job.status !== 'success') return null
  // Цепочка поставлена сервером — уведомлять не о чем: картинки уже рисуются,
  // и их прогон панель показывает сама (`useTranslationChain`).
  if (job.result?.next_job_id) return null
  const event = (job.result?.events ?? []).find((e) => e.stage === 'images')
  // Пустое сообщение — это ОТСУТСТВИЕ уведомления, а не уведомление пустотой:
  // итог рисует ветку по truthiness, и пустая строка закрыла бы прогон молча —
  // ровно то поведение, которое эта ветка и устраняет. Сигнатура обещает
  // `string | null`, поэтому «пусто» выражается `null`, а не `''`.
  return event?.message?.trim() ? event.message : null
}
